import { createRouter } from '@tanstack/react-router';
import { routeTree } from '@src/routeTree.gen.js';

// Create the router using your Route tree
export const router = createRouter({ routeTree });

// Register your router for maximum type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
